import "./Footer.css";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import { SiLinktree } from "react-icons/si";

const footerYear = new Date().getFullYear();

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo" rel="noreferrer">
        @citixenken
      </a>
      <ul className="permalinks">
        <li>
          <a href="#" rel="noreferrer">
            Home
          </a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        {/* <li>
          <a href="#services">Services</a>
        </li> */}
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        {/* <li>
          <a href="#testimonials">Testimonials</a>
        </li> */}
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div className="footer__socials">
        <a href="https://linktr.ee/citixenken" target="_blank" rel="noreferrer">
          <SiLinktree />
        </a>
        <a
          href="https://github.com/citixenken"
          target="_blank"
          rel="noreferrer"
        >
          <BsGithub />
        </a>
        <a
          href="https://www.linkedin.com/in/ken-muyesu/"
          target="_blank"
          rel="noreferrer"
        >
          <BsLinkedin />
        </a>
        {/* <a href="https://www.twitter.com/" target="_blank">
          <BsTwitter />
        </a> */}
      </div>
      <div className="footer__copyright">
        @citixenken Portfolio Website. &copy; {footerYear}. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
